var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDownloadWhite = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.4,
    height: 15.4,
    viewBox: "0 0 15.4 15.4",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a_downWhite{fill:#fff;opacity:0;}.a_downWhite,.b_downWhite{stroke:#fff;}.b_downWhite,.d_downWhite{fill:none;}.b_downWhite{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.4px;}.c_downWhite{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.7 0.7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a_downWhite"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c_downWhite",
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d_downWhite",
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b_downWhite",
    d: "M18.5,22.5v3.111a1.556,1.556,0,0,1-1.556,1.556H6.056A1.556,1.556,0,0,1,4.5,25.611V22.5",
    transform: "translate(0 -8.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b_downWhite",
    d: "M10.5,15l3.889,3.889L18.278,15",
    transform: "translate(-2.889 -5.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b_downWhite",
    d: "M18,13.833V4.5",
    transform: "translate(-6.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DownloadWhite.349afb2d.svg";
export { ForwardRef as ReactComponent };